// parse client
import Parse from 'parse'

Parse.initialize()
Parse.applicationId = process.env.REACT_APP_ID
Parse.javascriptKey = process.env.REACT_APP_JAVASCRIPT_KEY
Parse.serverURL = `${process.env.REACT_APP_PARSE_SERVER_PROTOCOL}${process.env.REACT_APP_PARSE_SERVER_ADDRESS}/parse`
Parse.masterKey = process.env.REACT_APP_MASTER_KEY
export default Parse
